import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import InscriptionForm from './InscriptionForm';
import {
  saveInscripcionExamen,
  getInscripcionExamen,
  getFormData,
} from '../../../../redux/actions/inscripcionExamenActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../helpers/notification';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import { Calificaciones } from '../../../../constants/enums';

class InscriptionFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleOnStudentChange = this.handleOnStudentChange.bind(this);
  }

  componentDidMount() {
    this.fetchFormDatas();
  }

  fetchFormDatas = () => {
    const { idExamen } = this.props;

    getFormData({
      idExamen,
      loadStudents: true,
      onSuccess: ({ examen, alumnos }) => {
        this.setState({
          examen, alumnos,
        });

        this.fetchInscriptionExamen();
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  fetchInscriptionExamen = () => {
    const { id, history } = this.props;
    if (!id) {
      const { examen: { fecha } } = this.state;
      this.setState({
        inscripcion: {
          id: 0,
          fechaInscripcion: fecha.toLocaleString(),
          porcentajeAsistencia: 0,
          porcentajePP: 0,
          porcentajePF: 0,
          porcentajePC: 0,
        },
      });

      return;
    }

    getInscripcionExamen(id, {
      onSuccess: (dto) => {
        const {
          usuarioId,
          studentId,
          nombre,
          apellido,
          anioInscripcion,
          calificacion,
        } = dto;

        const calificacionObj = Calificaciones.find(c => c.value === calificacion) || {};

        const inscripcion = {
          ...dto,
          alumnoObj: {
            value: studentId,
            parentId: usuarioId,
            label: `${usuarioId}/${anioInscripcion}: ${nombre} ${apellido}`,
          },
          calificacionObj,
        };
        this.setState({ inscripcion });
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('La inscripción a examen no existe');
          history.goBack();
        } else {
          createErrorMessage('Error al intentar cargar los datos de la inscripción.');
        }
      },
    });
  }

  handleSubmit = (values) => {
    const {
      id,
      alumnoObj: { value: perfilAlumnoId, parentId: usuarioId },
      fechaInscripcion,
      porcentajeAsistencia,
      porcentajePP,
      porcentajePF,
      porcentajePC,
      calificacionObj: { value: calificacion },
    } = values;

    const { examen: { id: examenId } } = this.state;

    const params = {
      id,
      examenId,
      usuarioId,
      perfilAlumnoId,
      fechaInscripcion,
      porcentajeAsistencia: +porcentajeAsistencia,
      porcentajePP: +porcentajePP,
      porcentajePF: +porcentajePF,
      porcentajePC: +porcentajePC,
      calificacion,
    };

    saveInscripcionExamen(params, {
      onSuccess: () => {
        const { history } = this.props;
        createSuccessMessage('Inscripción a examen guardado exitosamente');
        history.goBack();
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la inscripción examen');
        }
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnStudentChange = (value) => {
    const { inscripcion } = this.state;
    this.setState({
      inscripcion: {
        ...inscripcion,
        alumno: value,
        usuarioId: value.parentId,
        perfilAlumnoId: value.id,
      },
    });
  }

  render() {
    const { id, history } = this.props;
    const {
      examen,
      inscripcion,
      alumnos,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} inscripci&oacute;n y/o nota
            </h3>
            <h3 className="page-subhead subhead">
              Edita o ingresa la informaci&oacute;n de la inscripción o notas del alumno
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(alumnos)
              ? (<LoadingSpinner />)
              : (
                <InscriptionForm
                  {...inscripcion}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={inscripcion}
                  inscripcion={inscripcion}
                  history={history}
                  alumnos={alumnos}
                  examen={examen}
                  onAlumnoChanges={this.handleOnStudentChange}
                  enableReinitialize
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

InscriptionFormContainer.propTypes = {
  idExamen: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default InscriptionFormContainer;
